export default __webpack_public_path__ + "static/media/View-documentation.6246da07.md";